module.exports = __webpack_public_path__ + "static/media/pranav-2.79c064da.jpg";